import { useState } from 'react';
import styles from './RemoveAssignmentModal.module.scss';
import { AxiosError } from 'axios';
import { Button, Modal, Text } from 'components';
import { appActions } from 'store/app/slice';
import { selectCurrentPatientCase, selectPatientPageTimestamp } from 'store/patients/selectors';
import { patientsActions } from 'store/patients/slice';
import { useDispatch, useSelector } from 'store/utils';
import { PatientCaseErrorMessages } from 'types';

export const RemoveAssignmentModal = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const currentPatientCase = useSelector(selectCurrentPatientCase);
  const timestamp = useSelector(selectPatientPageTimestamp);

  const onClose = () => {
    dispatch(appActions.setIsModalOpened({ name: 'removeAssignment', isOpened: false }));
  };

  const onSubmit = async () => {
    if (!currentPatientCase?.id || !timestamp || isLoading) return;

    try {
      setIsLoading(true);
      await dispatch(
        patientsActions.removeAssignmentFromCase({
          assignCaseToDoctorData: {
            checkFrom: timestamp,
          },
          patientCaseId: currentPatientCase.id,
        }),
      ).unwrap();

      dispatch(patientsActions.setPatientPageTimestamp());

      onClose();
    } catch (e: unknown) {
      if (
        e instanceof AxiosError &&
        (e.response?.data.type === PatientCaseErrorMessages.assignedToAnotherDoctor ||
          e.response?.data.type === PatientCaseErrorMessages.notAssignedToAnyDoctor)
      ) {
        dispatch(patientsActions.setPatientPageTimestamp());
        onClose();
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title={'Remove assignment'} onClose={onClose}>
      <div className={styles.container}>
        <Text type="body-big">Are you sure you want to remove your assignment?</Text>
        <div className={styles.buttonRow}>
          <Button isLink onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit}>Remove</Button>
        </div>
      </div>
    </Modal>
  );
};
